export const preConfiguredThemesV2 = {
    orange: {
        headerColorFirst: "#fff", //header
        headerColorSecond: "#fff", // Header Section Color 2
        backgroundColorFirst: "#fc987c", // Background Color 1
        backgroundColorSecond: "#f77854", // Background Color 2
        textColor: "#fff", //genel yazı
        errorColor: "#FF4500", //error color
        representativeBubbleColor: "#fff", // temsilci balon rengi
        representativeTextColor: "#000", //temsilci konuşma rengi
        customerBubbleColor: "#F3643B", //ziyaretci balon rengi
        customerTextColor: "#FFF", // ziyaretçi yazı rengi
        buttonColor: "#F3643B", //buton rengi
        headerTextColor: "#000", //header yazı rengi
        formColorText: "#000000", //form yazı rengi
        chatBotButtonText: "#fff", //chatbot buton yazı rengi
        chatBotButtonColor: "transparent", //chatbot buton rengi
    },
    black: {
        headerColorFirst: "#fff", //header
        headerColorSecond: "#fff", // Header Section Color 2
        backgroundColorFirst: "#2e2e2e", // Background Color 1
        backgroundColorSecond: "#121212", // Background Color 2
        textColor: "#fff", //genel yazı
        errorColor: "#FF0000", //error color
        representativeBubbleColor: "#fff", // temsilci balon rengi
        representativeTextColor: "#000", //temsilci konuşma rengi
        customerBubbleColor: "#424242", //ziyaretci balon rengi
        customerTextColor: "#FFF", // ziyaretçi yazı rengi
        buttonColor: "#555555", //buton rengi
        headerTextColor: "#000", //header yazı rengi
        formColorText: "#000", //form yazı rengi
        chatBotButtonText: "#fff", //chatbot buton yazı rengi
        chatBotButtonColor: "transparent", //chatbot buton rengi
    },
    blue: {
        headerColorFirst: "#fff", //header
        headerColorSecond: "#fff", // Header Section Color 2
        backgroundColorFirst: "#6bb7ff", // Background Color 1
        backgroundColorSecond: "#359cff", // Background Color 2
        textColor: "#000", //genel yazı
        errorColor: "#FF0000", //error color
        representativeBubbleColor: "#fff", // temsilci balon rengi
        representativeTextColor: "#000", //temsilci konuşma rengi
        customerBubbleColor: "#085aaa", //ziyaretci balon rengi
        customerTextColor: "#FFF", // ziyaretçi yazı rengi
        buttonColor: "#6bb7ff", //buton rengi
        headerTextColor: "#000", //header yazı rengi
        formColorText: "#000000", //form yazı rengi
        chatBotButtonText: "#fff", //chatbot buton yazı rengi
        chatBotButtonColor: "transparent", //chatbot buton rengi
    },
    green: {
        headerColorFirst: "#fff", //header
        headerColorSecond: "#fff", // Header Section Color 2
        backgroundColorFirst: "#7ce157", // Background Color 1
        backgroundColorSecond: "#5ec737", // Background Color 2
        textColor: "#000", //genel yazı
        errorColor: "#FF0000", //error color
        representativeBubbleColor: "#fff", // temsilci balon rengi
        representativeTextColor: "#000", //temsilci konuşma rengi
        customerBubbleColor: "#349610", //ziyaretci balon rengi
        customerTextColor: "#FFF", // ziyaretçi yazı rengi
        buttonColor: "#006400", //buton rengi
        headerTextColor: "#000", //header yazı rengi
        formColorText: "#000000", //form yazı rengi
        chatBotButtonText: "#fff", //chatbot buton yazı rengi
        chatBotButtonColor: "transparent", //chatbot buton rengi
    },
    purple: {
        headerColorFirst: "#fff", //header
        headerColorSecond: "#fff", // Header Section Color 2
        backgroundColorFirst: "#c03ae3", // Background Color 1
        backgroundColorSecond: "#aa27ca", // Background Color 2
        textColor: "#000", //genel yazı
        errorColor: "#FF0000", //error color
        representativeBubbleColor: "#fff", // temsilci balon rengi
        representativeTextColor: "#000", //temsilci konuşma rengi
        customerBubbleColor: "#7e1499", //ziyaretci balon rengi
        customerTextColor: "#FFFFFF", // ziyaretçi yazı rengi
        buttonColor: "#7e1499", //buton rengi
        headerTextColor: "#000", //header yazı rengi
        formColorText: "#000", //form yazı rengi
        chatBotButtonText: "#fff", //chatbot buton yazı rengi
        chatBotButtonColor: "transparent", //chatbot buton rengi
    },
    red: {
        headerColorFirst: "#fff", //header
        headerColorSecond: "#fff", // Header Section Color 2
        backgroundColorFirst: "#fc383c", // Background Color 1
        backgroundColorSecond: "#e72829", // Background Color 2
        textColor: "#fff", //genel yazı
        errorColor: "#FF0000", //error color
        representativeBubbleColor: "#fff", // temsilci balon rengi
        representativeTextColor: "#000", //temsilci konuşma rengi
        customerBubbleColor: "#b9100d", //ziyaretci balon rengi
        customerTextColor: "#FFF", // ziyaretçi yazı rengi
        buttonColor: "#b9100d", //buton rengi
        headerTextColor: "#000", //header yazı rengi
        formColorText: "#000000", //form yazı rengi
        chatBotButtonText: "#fff", //chatbot buton yazı rengi
        chatBotButtonColor: "transparent", //chatbot buton rengi
    },
    yellow: {
        headerColorFirst: "#fff", //header
        headerColorSecond: "#fff", // Header Section Color 2
        backgroundColorFirst: "#ffb249", // Background Color 1
        backgroundColorSecond: "#fba32d", // Background Color 2
        textColor: "#fff", //genel yazı
        errorColor: "#FF3333", //error color
        representativeBubbleColor: "#fff", // temsilci balon rengi
        representativeTextColor: "#000", //temsilci konuşma rengi
        customerBubbleColor: "#d47f0b", //ziyaretci balon rengi
        customerTextColor: "#FFF", // ziyaretçi yazı rengi
        buttonColor: "#d47f0b", //buton rengi
        headerTextColor: "#000", //header yazı rengi
        formColorText: "#000000", //form yazı rengi
        chatBotButtonText: "#fff", //chatbot buton yazı rengi
        chatBotButtonColor: "transparent", //chatbot buton rengi
    },
    pink: {
        headerColorFirst: "#fff", //header
        headerColorSecond: "#fff", // Header Section Color 2
        backgroundColorFirst: "#ff85ae", // Background Color 1
        backgroundColorSecond: "#ff73a2", // Background Color 2
        textColor: "#000", //genel yazı
        errorColor: "#FF1493", //error color
        representativeBubbleColor: "#fff", // temsilci balon rengi
        representativeTextColor: "#000", //temsilci konuşma rengi
        customerBubbleColor: "#da2c67", //ziyaretci balon rengi
        customerTextColor: "#FFF", // ziyaretçi yazı rengi
        buttonColor: "#da2c66", //buton rengi
        headerTextColor: "#000", //header yazı rengi
        formColorText: "#000000", //form yazı rengi
        chatBotButtonText: "#fff", //chatbot buton yazı rengi
        chatBotButtonColor: "transparent", //chatbot buton rengi
    },
    gray: {
        headerColorFirst: "#fff", //header
        headerColorSecond: "#fff", // Header Section Color 2
        backgroundColorFirst: "#9f9f9f", // Background Color 1
        backgroundColorSecond: "#8d8d8d", // Background Color 2
        textColor: "#000", //genel yazı
        errorColor: "#FF0000", //error color
        representativeBubbleColor: "#fff", // temsilci balon rengi
        representativeTextColor: "#000", //temsilci konuşma rengi
        customerBubbleColor: "#424242", //ziyaretci balon rengi
        customerTextColor: "#FFF", // ziyaretçi yazı rengi
        buttonColor: "#666666", //buton rengi
        headerTextColor: "#000", //header yazı rengi
        formColorText: "#000000", //form yazı rengi
        chatBotButtonText: "#fff", //chatbot buton yazı rengi
        chatBotButtonColor: "transparent", //chatbot buton rengi
    },
    mango: {
        headerColorFirst: "#fff", //header
        headerColorSecond: "#fff", // Header Section Color 2
        backgroundColorFirst: "#ffb249", // Background Color 1
        backgroundColorSecond: "#fba32d", // Background Color 2
        textColor: "#000", //genel yazı
        errorColor: "#FF3333", //error color
        representativeBubbleColor: "#fff", // temsilci balon rengi
        representativeTextColor: "#000", //temsilci konuşma rengi
        customerBubbleColor: "#d47f0b", //ziyaretci balon rengi
        customerTextColor: "#FFF", // ziyaretçi yazı rengi
        buttonColor: "#d47f0b", //buton rengi
        headerTextColor: "#000", //header yazı rengi
        formColorText: "#000000", //form yazı rengi
        chatBotButtonText: "#fff", //chatbot buton yazı rengi
        chatBotButtonColor: "transparent", //chatbot buton rengi
    },
    servquick: {
        headerColorFirst: "#fff", // Header Color 1
        headerColorSecond: "#fff", // Header Color 2
        backgroundColorFirst: "#ECF0F1", // Background Color 1
        backgroundColorSecond: "#DADFE1", // Background Color 2
        textColor: "#000", // General Text Color
        errorColor: "#E74C3C", // Error Color
        representativeBubbleColor: "#fff", // Representative Bubble Color
        representativeTextColor: "#000", // Representative Text Color
        customerBubbleColor: "#85C1E9", // Customer Bubble Color
        customerTextColor: "#FFF", // Customer Text Color
        buttonColor: "#2980B9", // Button Color
        headerTextColor: "#000", // Header Text Color
        formColorText: "#000000", // Form Text Color
        chatBotButtonText: "#fff", // Chatbot Button Text Color
        chatBotButtonColor: "transparent", // Chatbot Button Color
    },
};
